<template>
    <div class="docs-page">
        <Headers />
        <div class="docs-container">
            待填充
        </div>
        <Footer />
    </div>
</template>
<script>
import Headers from '@/components/headers.vue'
import Footer from '@/components/footer.vue'
export default {
    name: 'Docs-node',
    components: {
        Headers,
        Footer
    }
}
</script>
<style scoped>
.docs-page {
    width: 100%;
    height: 100vh;
    background-color: #0d0d12;
}
.docs-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 100%;
    height: 100%;
    background-color: #0d0d12;
}
    </style>